import { useEffect, useState } from 'react';

const KEY = 'kazajah_admin_pwd';

/**
 * useInlineAdmin — small hook that mirrors the admin password stored in
 * localStorage by InlineAdminGate. Lets any component know if the visitor
 * is currently authenticated as admin without lifting state up to the root.
 */
export default function useInlineAdmin() {
  const read = () => {
    try { return localStorage.getItem(KEY) || ''; } catch { return ''; }
  };
  const [pwd, setPwd] = useState(read);

  useEffect(() => {
    const handler = () => setPwd(read());
    window.addEventListener('storage', handler);
    // Local same-tab updates: poll briefly
    const t = setInterval(handler, 500);
    return () => { window.removeEventListener('storage', handler); clearInterval(t); };
  }, []);

  const login = (password) => {
    try { localStorage.setItem(KEY, password); } catch {}
    setPwd(password);
  };
  const logout = () => {
    try { localStorage.removeItem(KEY); } catch {}
    setPwd('');
  };

  return { isAdmin: !!pwd, adminPwd: pwd, login, logout };
}
